module.exports = __webpack_public_path__ + "static/media/resetpass.cbe1b982.svg";